export const convert2StringifyValue = (options?: IGPSelectOption[] | null): string[] => {
  if (!Array.isArray(options) || !options.length) return [];
  return options.map((option) => option?.value);
};
